import { Controller } from "@hotwired/stimulus"
import { activateClickOnSpace, isActivationKey } from "../../../utils/keyboardAccessibility"

export default class extends Controller {
  toggleQuestionDetails(event) {
    event.preventDefault()
    const trigger = event.currentTarget.closest("[data-saq-id]") || event.currentTarget
    const saqId = trigger.dataset.saqId
    if (!saqId) return

    const questionDetails = document.getElementById(`saq-response-question-details-${saqId}`)
    if (questionDetails) {
      const isOpen = questionDetails.style.display !== "none"
      const willOpen = !isOpen
      const usesFlexLayout = questionDetails.classList.contains("flex")
      questionDetails.style.display = willOpen ? (usesFlexLayout ? "flex" : "block") : "none"
      questionDetails.setAttribute("aria-hidden", willOpen ? "false" : "true")

      const header = document.getElementById(`saq-question-header-${saqId}`)
      if (header) {
        header.setAttribute("aria-expanded", willOpen.toString())
      }

      const card = document.getElementById(`saq-question-card-${saqId}`)
      if (card) {
        card.classList.toggle("is-expanded", willOpen)
      }
    }

    const questionDetailsArrow = document.getElementById(`saq-question-details-arrow-${saqId}`)
    if (questionDetailsArrow) {
      questionDetailsArrow.classList.toggle("rotated")
    }

    const questionDetailsArrowMobile = document.getElementById(
      `saq-question-details-arrow-mobile-${saqId}`
    )
    if (questionDetailsArrowMobile) {
      questionDetailsArrowMobile.classList.toggle("rotated")
    }
  }

  checkEnterKeyToggleQuestionDetails(event) {
    if (!isActivationKey(event) && event.keyCode !== 13) return

    event.preventDefault()
    event.stopPropagation()
    this.toggleQuestionDetails(event)
  }

  activateLinkOnSpace(event) {
    activateClickOnSpace(event)
  }
}
